import { render, staticRenderFns } from "./LessonDeleteModalConfirmation.vue?vue&type=template&id=3cb8f02a"
import script from "./LessonDeleteModalConfirmation.vue?vue&type=script&lang=js"
export * from "./LessonDeleteModalConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports